import React from 'react';
import { SelectTrigger, SelectValue } from '@frontend/shadcn/components/ui/select';

interface SelectBaseProps {
  value: string | string[];
  placeholder?: string;
  isMulti?: boolean;
  hasValue?: boolean;
  children?: React.ReactNode;
}

export const SelectBase: React.FC<SelectBaseProps> = ({
  value,
  placeholder = '',
  isMulti = false,
  hasValue,
  children
}) => {
  const displayValue = isMulti && Array.isArray(value)
    ? value.join(', ')
    : value;

  return (
    <SelectTrigger
      className={`h-full border-0 bg-transparent focus:ring-0 focus:outline-none [&>svg]:text-zinc-900 [&>svg]:opacity-100
        ${hasValue ? 'pt-5 pb-1' : 'px-3'}`}
    >
      <SelectValue
        placeholder={placeholder}
        className="flex gap-1"
      >
        {displayValue}
      </SelectValue>
      {children}
    </SelectTrigger>
  );
};
